import { useEffect, useRef } from 'react';

export const useVisibilityChange = (
  callback: (isVisible: boolean) => void,
  options: IntersectionObserverInit = { threshold: 0.5 },
) => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const isVisible = useRef<boolean | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (isVisible.current !== entry.isIntersecting) {
        isVisible.current = entry.isIntersecting;
        callback(Boolean(entry.isIntersecting));
      }
    }, options);

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef.current]);

  return elementRef;
};
